import { render, staticRenderFns } from "./data_item.vue?vue&type=template&id=0e3d0755"
import script from "./data_item.vue?vue&type=script&lang=js"
export * from "./data_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports